<div class="relative flex h-full max-h-full overflow-hidden" data-testid="tree-container">
  <!-- Loading -->
  @if (loading) {
    <div class="fixed inset-0 flex items-center justify-center bg-[var(--surface)]/60">
      <gx-loader class="scale-150"></gx-loader>
    </div>
  }

  <!-- Tree structure -->
  @if (overviewData$ | async; as data) {
    @if (!loading) {
      <div class="hidden lg:flex h-full">
        <ng-container *ngTemplateOutlet="treeLevel; context: { parent: null, children: data, level: -1 }"></ng-container>

        @for (levelItem of selectedPath; track levelItem; let i = $index) {
          <ng-container
            *ngTemplateOutlet="treeLevel; context: {
              parent: i === 0 ? 'overview.overview' : selectedPath[i - 1].name,
              children: selectedPath[i].children,
              level: i}">
          </ng-container>
        }
      </div>

      <!-- Overlayed Details Panel -->
      @if (employeeEmail) {
        <div
          @slideInFromRight
          class="z-10 text-[var(--text)] bg-ui-surface-rise inset-0 fixed lg:relative lg:flex-1 overflow-auto"
        >
          <app-employee-details
            data-testid="team-employee-details"
            (closeClicked)="closeEmployeeDetails()"
            [employeeId]="employeeEmail">
          </app-employee-details>
        </div>
      }

      <!-- Overlayed Map Panel -->
      @if (mapElements.length > 0 && !employeeEmail) {
        <div
          @slideInFromRight
          class="z-10 text-[var(--text)] bg-ui-surface-rise inset-0 fixed lg:relative lg:flex-1 overflow-auto"
        >
          <app-leaflet-map
            (closeClicked)="closeMap()"
            [mapElements]="mapElements"
            >
          </app-leaflet-map>
        </div>
      }

      <!-- mobile -->
      <div class="flex flex-col w-full lg:hidden">
        @if (level >= 0) {
          <ng-container
            *ngTemplateOutlet="treeLevel; context: {
              parent: level === 0 ? 'overview.overview' : selectedPath[level - 1].name,
              children: selectedPath[level].children,
              level: level}">
          </ng-container>
        }
        @else {
          <ng-container
            *ngTemplateOutlet="treeLevel; context: { parent: null, children: data, level: -1 }">
          </ng-container>
        }
      </div>
    }
  }
</div>

<ng-template #treeLevel let-parent="parent" let-children="children" let-level="level">
  <div
    class="flex flex-col flex-none border-r border-[var(--border)] bg-[var(--surface)] text-[var(--text)] min-w-max h-full"
    *ngIf="parent === null || isLevelVisible(level)">
    @if (level >= 0) {
      <div>
        <button
          (click)="goBack()"
          class="flex items-center w-full p-2 text-left"
        >
          <fa-icon [icon]="'chevron-left'" class="mr-2"></fa-icon>
          <span class="font-bold">
            {{ parent | translate }}
          </span>
        </button>
      </div>
      <li class="p-2 bg-[var(--surface-rise)] text-xs border-b border-[var(--border)] flex justify-between items-center">
        <div class="flex items-center">
          @if (isEmployeeLevel(children)) {
            {{ "team.singular" | translate }}
          }
          @else {
            {{ getSubheadlineIdForKeyAnDepth(level) | translate }}
          }

          @if (children?.length) {
            <span class="text-gray-500 text-sm ml-1">
              ({{ children.length }})
            </span>
          }
        </div>

        @if (isEmployeeLevel(children)) {
          <gx-sorting-selector
            class="h-fit ml-4"
            direction="asc"
            [choices]="sortingItems"
            (directionChanged)="toggleSortOrder()" />
        }
      </li>
    }
    <ul class="list-none p-0 m-0 overflow-auto">
      @for (item of sortItems(children, level); track item) {
        <li
          class="font-bold cursor-pointer hover:bg-[var(--surface)] p-4 flex justify-between items-center border-b border-[var(--border)]"
          [ngClass]="{
            'text-[var(--active)] bg-[var(--surface)]': isItemSelected(item, level),
            'text-[var(--text)] bg-[var(--surface-rise)]': !isItemSelected(item, level)
          }"
          (click)="onItemClick(item, level + 1)">
          {{ item.name | translate }}
          @if (item.children?.length || item.count) {
            <span class="font-normal ml-6 rounded-full w-6 h-6 flex items-center justify-center text-xs flex-shrink-0 border border-[var(--border)]">
              {{ item.children?.length ?? item.count }}
            </span>
          }
        </li>
      }
    </ul>
  </div>
</ng-template>
